import api from "./api"

export async function getAllOpportunities (limit, query = '')
{
    try {
        const response = await api.get('/opportunities/index', {
            params: { 
                limit,
                query
            }
        });
    
        // Make sure your backend returns a `status` field, or check the HTTP status code
        if (response.data.status === 'success') {
            return response.data.data.data; // adjust according to your response structure
        }
    
        return []; // fallback
        } catch (error) {
            console.error('Failed to fetch categories:', error);
            return [];
        }
}


export async function storeOpportunity (data)
{
    try {
        const response = await api.post('/opportunities/store', data)
        if (response.data.status == 'success')
        {
            return true
        }
    } catch (error)
    {
        return error
    }
}

export async function updateOpportunity (data)
{
    try {
        const response = await api.post('/opportunities/update', data)
        if (response.data.status == 'success')
        {
            return true
        }
    } catch (error)
    {
        return error
    }
}

export async function getOpportunityById (id)
{
    try {
        const response = await api.get('/opportunities/show', {
            params: {
                id: id
            }
        })
        if (response.data.status == 'success')
        {
            return response.data.data
        }
        return []
    } catch (error)
    {
        console.error('Failed to fetch categories:', error);
        return [];
    }
}


// delete the opportunity

export async function destroyOpportunity (id)
{
    try {
        const response = await api.post('/opportunities/destroy', {
            id: id
        })

        if (response.data.status == 'success')
        {
            return true
        }

        else {
            return false
        }
    } catch (error)
    {
        return false
    }
}